var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui fluid search selection dropdown",
      attrs: { id: _vm.element_id }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.selection }
      }),
      _vm._v(" "),
      _c("i", { staticClass: "dropdown icon" }),
      _vm._v(" "),
      _c("div", { staticClass: "default text" }, [
        _vm._v(_vm._s(_vm.default_text))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu dropdown_menu" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5944ba09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5944ba09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Dropdown.vue
// module id = fl29
// module chunks = 1